export default __webpack_public_path__ + "static/media/Letrero con lectura.6c375fc0.png";